import * as Constants from './Constants';
import safeGetAttribute from './safeGetAttribute';
import tryCreateDataURIFromImage from './tryCreateDataURIFromImage';
import addInlineImageToStore from '../actions/addInlineImageToStore';
import { INLINEIMAGE_ATTRIBUTE_ORIGINALSRC } from 'owa-inline-image-consts';

/**
 * Cache the inline image
 * @param img The image
 */
export default function cacheInlineImage(img: HTMLImageElement) {
    const srcValue = safeGetAttribute(img, Constants.ATTRIBUTE_SRC);
    const originalSrcValue = safeGetAttribute(img, INLINEIMAGE_ATTRIBUTE_ORIGINALSRC);
    if (srcValue.length > 0 && originalSrcValue.length > 0) {
        const dataUri = tryCreateDataURIFromImage(img);
        if (dataUri) {
            // Add the dataUri for the inline image to store, keyed by originalSrc
            addInlineImageToStore(originalSrcValue, dataUri);
        }
    }
}
